var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import React from "react";
import { IconSpinner } from "@wrstudios/icons";
import { PreviewDetails, Address, LayoutWithSpaceBetween, SubAddress, Status } from "./styled/listing-popup";
import { Container, PreviewBox, PreviewImage, NoImagePlaceholder, Price, Loading } from "./styled/listing-popup";

function ListingPopup(_a) {
  var id = _a.id,
      _b = _a.photos,
      photos = _b === void 0 ? [] : _b,
      address = _a.address,
      city = _a.city,
      priceFormatted = _a.priceFormatted,
      state = _a.state,
      zip = _a.zip,
      statusLabel = _a.statusLabel,
      _c = _a.statusValue,
      statusValue = _c === void 0 ? "" : _c,
      _d = _a.offsetX,
      offsetX = _d === void 0 ? 0 : _d,
      _e = _a.offsetY,
      offsetY = _e === void 0 ? -5.5 : _e,
      props = __rest(_a, ["id", "photos", "address", "city", "priceFormatted", "state", "zip", "statusLabel", "statusValue", "offsetX", "offsetY"]);

  if (!address) {
    return React.createElement(Container, null, React.createElement(Loading, null, React.createElement(IconSpinner, null)));
  } else {
    return React.createElement(Container, __assign({
      offsetX: offsetX,
      offsetY: offsetY
    }, props), React.createElement(PreviewBox, null, Boolean(photos[0]) ? React.createElement(PreviewImage, {
      src: photos[0],
      alt: "Photo of " + address
    }) : React.createElement(NoImagePlaceholder, null, "Photo not available"), React.createElement(Price, null, priceFormatted)), React.createElement(PreviewDetails, null, React.createElement(Address, null, address), React.createElement(LayoutWithSpaceBetween, null, React.createElement(SubAddress, null, city, ", ", state, " ", zip), React.createElement(Status, {
      statusValue: statusValue
    }, statusLabel))));
  }
} // TODO: Using default props here as search marker relies on them.
// TODO: Codesmelly, fix later
// TODO: See src\components\search-map\SearchMarker.js:15,16


ListingPopup.defaultProps = {
  offsetX: 0,
  offsetY: -5.5
};
export default ListingPopup;